export enum typesKebab {
  NORMAL = 'normal',
  DISABLED = 'disabled',
  RED = 'red'
}
